import { useEffect, useState } from 'react';
import { Formalite, useFormaliteService } from '@europrocurement/l2d-domain';

type RequestStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

/**
 * Récupère la liste des formalités qui référencent le type de document donné.
 *
 * L'API formalités ne propose pas de filtre serveur par document : on récupère
 * donc l'ensemble des formalités (OpenSearch) puis on filtre celles dont le
 * tableau `documents` contient l'identifiant du type de document courant.
 */
const useDocumentTypeFormalities = (documentTypeId: number | undefined) => {
    const { formaliteOpenSearchApi } = useFormaliteService();
    const [formalities, setFormalities] = useState<Formalite[]>([]);
    const [status, setStatus] = useState<RequestStatus>('idle');

    useEffect(() => {
        if (!documentTypeId) {
            return;
        }

        let cancelled = false;
        setStatus('loading');

        formaliteOpenSearchApi
            .apiOpensearchFormalitesGetCollection({ itemsPerPage: 2000 })
            .then((res) => {
                if (cancelled) {
                    return;
                }
                const members =
                    (res.data as unknown as { 'hydra:member'?: Formalite[] })['hydra:member'] ?? [];
                setFormalities(
                    members.filter((formality) =>
                        (formality.documents ?? []).includes(documentTypeId),
                    ),
                );
                setStatus('succeeded');
            })
            .catch(() => {
                if (!cancelled) {
                    setStatus('failed');
                }
            });

        // eslint-disable-next-line consistent-return
        return () => {
            cancelled = true;
        };
    }, [documentTypeId, formaliteOpenSearchApi]);

    return { formalities, status };
};

export default useDocumentTypeFormalities;
